const AssetAllocationsChart = require('./AssetAllocationsChart');

module.exports = AssetAllocationsChart;
